import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import Loader from '../components/Loader';
import { useDispatch } from 'react-redux';

// Loader Component
// const Loader = () => <div>Loading...</div>;

// BasicModal Component


// App Component
export default function App(props) {
  const [modalProps, setModalProps] = React.useState({
    name: '',
    product: '',
    deleteType: '',
    chosen: { id: '' },
    dispatcher: () => ({ type: '' })
  });
  const setfalser = () => setOpen(false);


    const [open, setOpen] = React.useState(props.value);
    const [loading, setloading] = React.useState(false);
    const [snackbarOpen, setSnackbarOpen] = React.useState(false);
    const [snackbarMessage, setSnackbarMessage] = React.useState('');
    const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
    const [personName, setPersonName] = React.useState([]); // Retained for potential form use
    const dispatch = useDispatch();
  
    const handleClose = () => {
      setOpen(false);
      props.setfalser();
      setPersonName([]); // Clear personName state as a proxy for form data
    };
  
    const handleSnackbarClose = (event, reason) => {
      if (reason === 'clickaway') return;
      setSnackbarOpen(false);
    };
  
    const deleter = async () => {
      setloading(true);

      console.log("props")
      console.log(props)
      try {
        const link = `https://server.agrotraciserp.com/api/${props.delete}/delete${props.delete}/`;
        const res = await axios.post(link, { id: props.name==="mechanization"? props.chosen._id: props.chosen.id });

        if (res.status === 200) {
          setloading(false);
          dispatch(props.dispatcher({ data: res.data }));
          setSnackbarMessage(`Successfully deleted ${props.product} from ${props.name}!`);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setPersonName([]); // Clear state
          handleClose();
        } else {
          setloading(false);
          setSnackbarMessage(`Failed to delete ${props.product} from ${props.name}.`);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      } catch (err) {
        setloading(false);
        setSnackbarMessage(`An error occurred while deleting ${props.product} from ${props.name}.`);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      }
    };
  
 

  // // Mock dispatchers for different entity types
  // const dispatchers = {
  //   customer: (payload) => ({ type: 'customer/getcustomer', payload }),
  //   farmer: (payload) => ({ type: 'farmer/getfarmer', payload }),
  //   commodity: (payload) => ({ type: 'commodity/getcommodity', payload }),
  //   expenses: (payload) => ({ type: 'expenses/getexpenses', payload }),
  //   hauller: (payload) => ({ type: 'hauller/gethauller', payload }),
  //   processingcenter: (payload) => ({ type: 'processingcenter/getprocessingcenter', payload }),
  //   product: (payload) => ({ type: 'product/getproduct', payload }),
  //   requisition: (payload) => ({ type: 'requisition/getrequisition', payload }),
  //   sales: (payload) => ({ type: 'sales/getsales', payload }),
  //   service: (payload) => ({ type: 'service/getservice', payload }),
  //   staff: (payload) => ({ type: 'staff/getstaff', payload }),
  //   contract: (payload) => ({ type: 'contract/getcontract', payload }),
  //   warehouse: (payload) => ({ type: 'warehouse/getwarehouse', payload })
  // };

  // const openDeleteDialog = (name, product, deleteType) => {
  //   setModalProps({
  //     name,
  //     product,
  //     deleteType,
  //     chosen: { id: `mock-id-${deleteType}` }, // Mock ID; replace with actual ID
  //     dispatcher: dispatchers[deleteType] || (() => ({ type: '' }))
  //   });
  //   setOpen(true);
  // };

  return (
    <div>
      <Dialog fullWidth minWidth="sm" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title">
          Delete {props.name}
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box>
            <Typography align="center">
              Are you sure you want to delete <b>{props.product}</b> from {props.name} list?
            </Typography>
            <div style={{ textAlign: 'center', margin: '10px' }}>
              {loading ? (
                <Button variant="outlined" startIcon={<Loader />} disabled>
                  Loading...
                </Button>
              ) : (
                <Button variant="outlined" startIcon={<DeleteIcon />} onClick={deleter}>
                  Yes, Delete {props.product}
                </Button>
              )}
            </div>
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions />
      </Dialog>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );

}